import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class AuthService {

    baseUrl = `${environment.apis.base}`;
    cookieValue = 'NA';
    jwt = null;

    constructor(private readonly http: HttpClient) { }

    login(credentials): Observable<Object> {
        return this.http.post(`${this.baseUrl}/login`, credentials, { withCredentials: true }).pipe(
            tap((response: any) => {
                if (response.user) {
                    localStorage.setItem('user', JSON.stringify(response.user));
                    localStorage.setItem('access_token', response.token);
                } else {
                    console.error("No se recibió información del usuario en la respuesta.");
                }
            })
        );
    }

    refreshToken(): Observable<Object> {
        return this.http.post<any>(`${this.baseUrl}/refresh`, {}).pipe(
            tap((data: any) => {
                localStorage.setItem('access_token', data.token);
            })
        );
    }
    getCurrentUser() {
        const user = localStorage.getItem('user');
        return user ? JSON.parse(user) : null;
    }

    logout(): void {
        this.http.get<any>(`${this.baseUrl}/logout`).pipe(
            tap((data: any) => {
                localStorage.removeItem('access_token');
                localStorage.removeItem('netride_user_role');
            })
        );
    }

    isAuthenticated(): boolean {
        let isAuthorized = false;
        if (window.localStorage.getItem('access_token')) {
            isAuthorized = true;
        }

        return isAuthorized;
    }
    getProfile(): Observable<any> {
        return this.http.get<any>(`${this.baseUrl}/profile`).pipe(
            tap((data: any) => {
                if (data.user) {
                    localStorage.setItem('user', JSON.stringify(data.user));
                } else {
                    console.error("No se recibió información del usuario en la respuesta del perfil.");
                }
            })
        );
    }
    getRolData(): Observable<any> {
        return this.http.get<any>(`${this.baseUrl}/users/roles/getAll`).pipe(
            tap((data: any) => {
                const roles = data.response;
                localStorage.setItem('netride_user_role', roles[0]);
            })
        );
    }

    get userRole(): string {
        return localStorage.getItem('netride_user_role') || null;
    }

    get token(): string {
        return localStorage.getItem('access_token');
    }

}
